module.exports = __webpack_public_path__ + "img/gift_banner.3315cd04.jpg";